export default __webpack_public_path__ + "static/mik-ca42e36c3a98dabf0ca13cb67082e877.jpg";